module.exports = __webpack_public_path__ + "static/sonar-8aed4bcdd820b8be1bd494c33d8d5a12.mp3";